module.exports = __webpack_public_path__ + "img/next-disabled.8edfdda2.svg";